// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Rh5O","inner":"Footer_inner__1_I1V"};